// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .sbscr .fuzzy-dates-select {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    gap: 16px;\n  }\n  .root .sbscr .fuzzy-dates-select__months {\n    width: 100%;\n    max-width: calc(70px * 12);\n  }\n  .root .sbscr .fuzzy-dates-select__days {\n    position: relative;\n    max-width: 639px;\n    width: 100%;\n  }\n", ""]);
// Exports
module.exports = exports;
